import ApiClient from './ApiClient';

class InternalChatAPI extends ApiClient {
    constructor() {
        super('internal_conversations', { accountScoped: true });
    }

    getConversations() {
        return axios.get(this.url);
    }

    getMessages(conversationId) {
        return axios.get(`${this.url}/${conversationId}`);
    }

    createConversation(userId) {
        return axios.post(this.url, { user_id: userId });
    }

    sendMessage(conversationId, content) {
        return axios.post(`${this.url}/${conversationId}/send_message`, { content });
    }

    markRead(conversationId) {
        return axios.post(`${this.url}/${conversationId}/mark_read`);
    }

    getAvailableUsers() {
        return axios.get(`${this.url}/available_users`);
    }

    broadcastAlert({ message, userIds, teamIds }) {
        return axios.post(`${this.url}/broadcast_alert`, {
            message,
            user_ids: userIds,
            team_ids: teamIds,
        });
    }
}

export default new InternalChatAPI();
